<h2 mat-dialog-title class="modal-title">Upload Meeting Note</h2>

<mat-dialog-content>
  <form [formGroup]="form" class="upload-form">

    <mat-form-field appearance="outline" class="full-width">
      <mat-label>Meeting Description</mat-label>
      <input matInput formControlName="meetingDescription" placeholder="Enter meeting description" />
      @if (form.get('meetingDescription')?.invalid && form.get('meetingDescription')?.touched) {
        <mat-error>Meeting description is required.</mat-error>
      }
    </mat-form-field>

    <mat-form-field appearance="outline" class="full-width">
      <mat-label>Meeting Date</mat-label>
      <input matInput [matDatepicker]="picker" formControlName="meetingDate" placeholder="MM/DD/YYYY" [max]="maxDate" />
      <mat-datepicker-toggle matIconSuffix [for]="picker"></mat-datepicker-toggle>
      <mat-datepicker #picker></mat-datepicker>
      @if (form.get('meetingDate')?.invalid && form.get('meetingDate')?.touched) {
        <mat-error>Meeting date is required.</mat-error>
      }
    </mat-form-field>

    <!-- File Upload Area -->
    <div
      class="file-drop-zone"
      [class.dragging]="isDragging"
      [class.has-file]="selectedFile"
      (dragover)="onDragOver($event)"
      (dragleave)="onDragLeave($event)"
      (drop)="onDrop($event)"
      (click)="triggerFileInput()"
    >
      <input
        #fileInput
        type="file"
        accept=".pdf,.doc,.docx,application/pdf,application/vnd.openxmlformats-officedocument.wordprocessingml.document,application/msword"
        style="display: none"
        (change)="onFileSelected($event)"
      />

      @if (!selectedFile) {
        <div class="drop-zone-content">
          <mat-icon class="upload-icon">upload_file</mat-icon>
          <p class="drop-text">Drag & drop a file here, or click to select</p>
          <p class="file-type-hint">Supported: PDF, Word (.doc, .docx)</p>
        </div>
      } @else {
        <div class="file-selected-content" (click)="$event.stopPropagation()">
          <mat-icon class="file-icon" [class.file-icon--pdf]="selectedFile.name.toLowerCase().endsWith('.pdf')" [class.file-icon--word]="!selectedFile.name.toLowerCase().endsWith('.pdf')">{{ selectedFile.name.toLowerCase().endsWith('.pdf') ? 'picture_as_pdf' : 'description' }}</mat-icon>
          <span class="file-name">{{ selectedFile.name }}</span>
          <button mat-icon-button class="remove-file-btn" (click)="removeFile()" title="Remove file">
            <mat-icon>close</mat-icon>
          </button>
        </div>
      }
    </div>

    @if (fileTypeError) {
      <p class="file-error">{{ fileTypeError }}</p>
    }

    <mat-checkbox formControlName="sendNotification" class="notification-checkbox">
      Send notification to organization on save
    </mat-checkbox>

  </form>
</mat-dialog-content>

<mat-dialog-actions align="end">
  <button
    mat-button
    id="saveButton"
    [disabled]="!canSave || (uploading$ | async)"
    (click)="onSave()"
  >
    @if (uploading$ | async) {
      <mat-spinner diameter="18" style="display: inline-block; margin-right: 8px;"></mat-spinner>
    }
    Save
  </button>
  <button mat-button (click)="onClose()">Close</button>
</mat-dialog-actions>
